(function() {
    'use strict';
    angular
        .module('expedientesUriarteApp')
        .factory('Document', Document);

    Document.$inject = ['$resource', 'DateUtils'];

    function Document ($resource, DateUtils) {
        var resourceUrl =  'api/documents/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.register_date = DateUtils.convertLocalDateFromServer(data.register_date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.register_date = DateUtils.convertLocalDateToServer(copy.register_date);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.register_date = DateUtils.convertLocalDateFromServer(data.register_date);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.register_date = DateUtils.convertLocalDateToServer(copy.register_date);
                    return angular.toJson(copy);
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.register_date = DateUtils.convertLocalDateFromServer(data.register_date);
                    }
                    return data;
                }
            }
        });
    }
})();
